import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducer/index';
import thunk from 'redux-thunk';
import { api } from '../../middleware/api';

export const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, applyMiddleware(thunk, api));
};
